import React, { useState } from 'react';
import { Modal, Box, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import './QuestionCellViewModal.scss'

const QuestionCellViewModal = ({ value }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <span
        style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
        onClick={handleOpen}
      >
        {value}
      </span>

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: '8px',
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography variant="h6" component="h2">
            Question <CloseIcon className='close-icon' onClick={handleClose}/>
          </Typography>
          <Typography sx={{ mt: 2 }}>
            {value}
          </Typography>
        </Box>
      </Modal>
    </>
  );
};

export default QuestionCellViewModal;
